<mat-sidenav-container class="sidenav-container" autosize>
  <mat-sidenav
    class="sidenav"
    [class.sidenav__minimized]="!sidenavOpened"
    mode="side"
    opened
    disableClose
    (keydown.escape)="closeSidenav()"
  >
    <app-sidenav [(opened)]="sidenavOpened"></app-sidenav>
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
    <footer class="footer">{{ footerText }}</footer>
  </mat-sidenav-content>
</mat-sidenav-container>
